import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

import Modal from '../../common/Modal'
import SubmitButton from '../../common/buttons/SubmitButton'
import { ReactComponent as WarningIcon } from '../../../assets/images/common/icons/warning-icon.svg'

import classes from './ConfirmActionModal.module.scss'

// Shared confirmation dialog for E&B actions: warning triangle, title, message, and stacked
// confirm (orange) / cancel (navy) buttons. Used for delete-enrollment (Figma 1932-15253) and
// mark-as-outstanding (Figma 1932-15784).
const ConfirmActionModal = ({ isOpen, onClose, onConfirm, isLoading, title, message, confirmMessage, cancelMessage }) => {
  const { t } = useTranslation()

  return (
    <Modal isOpen={isOpen} onClose={onClose} className={classes.modal}>
      <div className={classes.content}>
        <WarningIcon className={classes.icon} />
        <h2 className={classes.title}>{title}</h2>
        <p className={classes.message}>{message}</p>
        <SubmitButton
          buttonMessage={confirmMessage}
          buttonColor='orange-button'
          loading={isLoading}
          disabled={isLoading}
          onClick={onConfirm}
        />
        <SubmitButton buttonMessage={cancelMessage || t('enrollmentsBilling.confirmModal.cancel')} buttonColor='navy-button' onClick={onClose} />
      </div>
    </Modal>
  )
}

ConfirmActionModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  confirmMessage: PropTypes.string.isRequired,
  cancelMessage: PropTypes.string,
}

export default ConfirmActionModal
